export default (constructionId: string): string => {
  return constructionId.replace("(", "").replace(")", "");
};
